module.exports = __webpack_public_path__ + "img/logo_pvm_fixed.384cd337.png";